<!--
 * @Description: 签约客户基本详情
 * @Author: cxh
 * @Date: 2022-05-24 15:19:34
 * @LastEditTime: 2022-11-17 16:54:45
 * @LastEditors: cxh
-->
<template>
  <dc-layout-main>
    <dc-layout-content>
      <baseMessage
        :perfect="true"
        :disabled="false"
        :permissionPage="permissionBasic"
        :data="data"
        type="contract"
      />
    </dc-layout-content>
  </dc-layout-main>
</template>
<script lang="ts" setup>
import { onMounted, ref } from 'vue'
import baseMessage from '@/views/gucangSales/customerCenter/components/baseMessage.vue'
import { useRoute } from 'vue-router'
import { potentialDetail } from '@/api/gucangSales/customerCenter'
const route = useRoute()
const data = ref({})
// 获取详情
const fetch = () => {
  if (route.query.cosId) {
    potentialDetail(route.query.cosId).then((res) => {
      data.value = res.data
    })
  }
}
const permissionBasic = {
  save: 'fbu_contract_edit_btn',
  editCode: 'fbu_contract_edit_name_or_code_btn'
}
onMounted(() => {
  fetch()
})
</script>
<script lang="ts">
export default { name: 'DcCosFbuContractEdit' }
</script>
